import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

// Registrar os componentes necessários
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const GraficoEstoque = ({ indicador }) => {
  // Dados fixos (fake)
  const data = {
    labels: ['Confortável', 'Estoque Baixo', 'Sem Estoque'],
    datasets: [
      {
        label: 'Quantidade de Produtos',
        data: [
          indicador.totalAcimaDoMinimo,
          indicador.totalAbaixo,
          indicador.totalZerados,
        ],
        backgroundColor: ['#4caf50', '#ff9800', '#f44336'],
      },
    ],
  }

  // Configurações opcionais
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // remove legenda
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px', textAlign: 'center' }}>
      <Bar data={data} options={options} />
    </div>
  )
}

export default GraficoEstoque
